export interface ServerMessage {
  type: string;
  data?: Record<string, unknown> | null;
  sequenceId?: string;
  timestamp?: number | string;
  [key: string]: unknown;
}

const HANDSHAKE_ACK_TYPE = 'handshake.ack';
const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export function validateServerMessage(message: unknown): message is ServerMessage {
  if (!isRecord(message)) {
    return false;
  }

  const { type } = message;
  if (typeof type !== 'string' || type.length === 0) {
    return false;
  }

  if ('sequenceId' in message && message.sequenceId !== undefined && typeof message.sequenceId !== 'string') {
    return false;
  }

  if ('timestamp' in message) {
    const ts = message.timestamp;
    if (ts !== undefined && ts !== null && typeof ts !== 'number' && typeof ts !== 'string') {
      return false;
    }
  }

  if ('data' in message && message.data !== undefined && message.data !== null && !isRecord(message.data)) {
    return false;
  }

  // Validate handshake acknowledgment from server
  if (type === HANDSHAKE_ACK_TYPE) {
    const data = message.data;
    if (!isRecord(data)) {
      return false;
    }

    if (typeof data.protocol_version !== 'string') {
      return false;
    }

    if (!isRecord(data.contract_versions)) {
      return false;
    }

    const serializers = data.serializers;
    if (
      !isRecord(serializers) ||
      !Array.isArray(serializers.supported) ||
      serializers.supported.some((item: unknown) => typeof item !== 'string')
    ) {
      return false;
    }
  }

  return true;
}
